import React from 'react'
import { string, array, object, number } from 'prop-types'
import GridWithAdvert from '@/component/Primitive/GridWithAdvert'
import changeFileExtension from '@/lib/filename-extension-modifier'

const GridWithAdvertWidget = ({
  suffix,
  articles,
  slotName,
  advertLocation,
  keyValueTargeting,
  section,
  article,
  rowIndex,
  pageData
}) => {
  const { isDesktop } = pageData
  const formattedArticles = articles.results?.map((a, i) => ({
    id: a._id,
    sell: a.sell,
    title: a.headline,
    description: a.sell,
    link: a.fullUrlPath,
    rowIndex,
    articleIndex: i,
    isDesktop,
    src: a.images?.thumbnail_landscape_322?.[0]?.url,
    srcSet: [
      {
        src: changeFileExtension(
          a.images?.thumbnail_landscape_322?.[0]?.url,
          'webp'
        ),
        width: 322
      },
      {
        src: changeFileExtension(
          a.images?.thumbnail_landscape_644?.[0]?.url,
          'webp'
        ),
        width: 644
      },
      {
        src: changeFileExtension(
          a.images?.thumbnail_landscape_900?.[0]?.url,
          'webp'
        ),
        width: 900
      }
    ],
    sizes: [
      '(min-width: 1440px) 334px',
      // 388 = padding between cards (24px) + content gutter (64px) + size of sibling card (300px)
      '(min-width: 960px) calc(50vw - 388px)',
      'calc(100vw - 32px)'
    ]
  }))
  const advertProps = {
    suffix,
    slotName,
    size: '300x250',
    keyValueTargeting,
    alignment: 'right',
    section,
    article
  }

  return (
    <GridWithAdvert
      advertLocation={advertLocation}
      advertProps={advertProps}
      articles={formattedArticles}
      pageData={pageData}
    />
  )
}

GridWithAdvertWidget.propTypes = {
  suffix: string,
  articles: object,
  section: object,
  article: object,
  slotName: string,
  advertLocation: string,
  keyValueTargeting: array,
  rowIndex: number,
  pageData: object
}

export default GridWithAdvertWidget
